<template>
  <div :class="`m-portal m-portal-${routeType}-page`">
    <portal-nav-top></portal-nav-top>
    <div id="ljh-travel">
      <div class="container-fluid" style="width:1100px;">
        <el-row :gutter="20">
          <el-col :span="6" class="left-menu-wrap">
            <portal-dest-nav></portal-dest-nav>
          </el-col>
          <el-col :span="18" class="content-page-wrap">
            <div class="content-page">
              <div class="navigation">
                <span>首页</span>
                <span>&nbsp;>&nbsp;</span>
                <span>文化旅游</span>
                <span>&nbsp;>&nbsp;</span>
                <span>{{title[$route.params._field]}}</span>
                <!-- <span>门票信息</span> -->
              </div>
              <div class="container">
                <el-row :gutter="20">
                  <bs-page :filter="filter" :meta="meta" ref="refId" content-class>
                    <template slot="data" slot-scope="slot">
                      <el-col
                        :span="8"
                        v-for="item in slot.data"
                        :key="item.merId"
                        @click="handleDetail(item)"
                        class="list-wrap"
                      >
                        <div @click="handleDetail(item)" class="item" style="cursor:pointer;">
                          <img
                            :src="item.imgUrl||$app.nodata.img"
                            :alt="item.merName"
                            class="img-fluid"
                            style="height:140px;"
                          />
                          <h5
                            class="title"
                            style="text-align: left; margin-left: 10px;font-size: 14px;"
                            v-text="item.childDest.destName+'-'+item.merName"
                          ></h5>
                          <p class="detail" >{{item.description||'暂无描述信息'}}</p>
                          <h3>￥{{item.price ||'--'}} 起</h3>
                        </div>
                        <div class="bottom">&nbsp;</div>
                      </el-col>
                    </template>
                    <template slot="empty">
                      <div>
                        <img src="../../assets/portal/zwsj.png" style="width:100%;height:300px" />
                      </div>
                    </template>
                    <template slot="paging" slot-scope="slot">
                      <el-pagination
                        style="float:clear; clear:both;margin:0 auto;text-align: center"
                        v-if="slot.data.totalCount>20"
                        layout="prev, pager, next"
                        background
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="filter.pageIndex"
                        :page-size="filter.pageSize"
                        :total="slot.data.totalCount"
                      ></el-pagination>
                    </template>
                  </bs-page>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <portal-footer></portal-footer>
  </div>
</template>
<script>
require("../../styles/portal/travel.scss");
export default {
  data() {
    return {
      title: {
        ticket: "门票信息"
      },
      routeType: "merd",
      meta: {
        module: this.$route.params._module,
        field: this.$route.params._field
      },
      filter: {
        pageIndex: 1,
        pageSize: 12
      },
      api: null
    };
  },
  mounted() {},
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BsPage: () => import("../../components/bs-page"),
    PortalNavTop: () => import("./portal-nav-top"),
    PortalNavLeft: () => import("./portal-nav-left"),
    PortalDestNav: () => import("./portal-dest-nav"),
    PortalFooter: () => import("./portal-footer")
  },
  methods: {
    handleDetail(item) {
      let _module = this.$route.params._module;
      let _field = this.$route.params._field;
      this.$router.push({
        path: `/portal/merd/detail/${_module}/${_field}_detail/${item.merId}`
      });
    },
    pageSizeChange(val) {
      let that = this;
      that.filter.pageSize = val;
      this.$refs["refId"].loadData();
    },
    pageIndexChange(val) {
      let that = this;
      that.filter.pageIndex = val;
      this.$refs["refId"].loadData();
    }
  },
  created() {
    //this.$menuFn.setTitle("门票信息");
    this.$menuFn.setTitle(
      this.title[this.$route.params._field] + "-朱子文化·综合信息服务平台"
    );
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "portal-merd-page") {
        // this.$menuFn.setTitle("门票信息");
        this.$menuFn.setTitle(
          this.title[this.$route.params._field] + "-朱子文化·综合信息服务平台"
        );
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "page",
        "portal"
      );
      if (this.routeWatch && contains) {
        this.$refs["refId"].clearData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.$refs["refId"].loadData();
      }
    }
  }
};
</script>
<style lange="sass" scoped>
.detail {
  margin: 3px;
  padding: 0;
  text-align: left;
  margin-left: 10px;
  height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
h3 {
  margin: 5px;
  padding: 0;
  font-size: 14px;
  text-align: left;
  margin-left: 10px;
}
</style>